import { networkGroup } from './utils'

const initialised = state => state.launch.initialised
const config = state => state.launch.config
const pool = state => state.launch.pool
const vm = state => state.launch.vm
const lease = state => state.launch.lease
const stage = state => state.launch.stage
const poolLogs = state => state.launch.poolLogs
const vmLogs = state => state.launch.vmLogs

const selectors = {
  initialised,
  config,
  pool,
  lease,
  vm,
  stage,
  poolLogs,
  vmLogs,
  ...networkGroup('launch', [
    'create',
  ])
}

export default selectors
